import { render, staticRenderFns } from "./projectgroupuser.vue?vue&type=template&id=7215cb92&"
import script from "./projectgroupuser.vue?vue&type=script&lang=js&"
export * from "./projectgroupuser.vue?vue&type=script&lang=js&"
import style0 from "./projectgroupuser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports